module.exports = __webpack_public_path__ + "assets/img/1-0.4ac90d52.svg";